import React from 'react';
import AVText from '../../../AVText';
import Localized from 'src/constants/AppStrings';

export default () => (
  <AVText>{Localized.Labels.required_keypad_not_recognized}</AVText>
);
